// extracted by mini-css-extract-plugin
module.exports = {"cta":"styles_cta__VDDvA","spin":"styles_spin__QMVyK"};